import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { CompanyInfo } from '../../components/custom/bottom/CompanyInfo';
import { ClosingSection } from './components/ClosingSection';
import { FixedBottomSection } from './components/FixedBottomSection';
import { FixedHeaderSection } from './components/FixedHeaderSection';
import { InnovationsSection } from './components/InnovationsSection';
import { ReviewVideoCtaSection } from './components/ReviewVideoCtaSection';
import { StatsSection } from './components/StatsSection';
import { TopSection } from './components/TopSection';
import { WorkExperienceSection } from './components/WorkExperienceSection';

export const PluvaIonLandingPage = () => {
  const handlePluvaIonInquiryButton = () => {
    ReactGA.event('pvm_click_pluva_ion_inquiry_button');
    window.location.href = 'tel:15335502';
  };

  return (
    <>
      <Helmet>
        <title>플루바 아이온</title>
      </Helmet>

      <FixedHeaderSection />
      <FixedBottomSection />

      <Container>
        <TopSection />

        <StatsSection />

        <ReviewVideoCtaSection />

        <InnovationsSection />

        <WorkExperienceSection />

        <ClosingSection />

        <CompanyInfo />
      </Container>
    </>
  );
};

const Container = styled.div`
  width: 100%;
  padding-top: 80px;
  padding-bottom: 72px;
  max-width: 512px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background-color: #000000;
`;
